import { NotificationItemData, NotificationQueryItem } from '../../types';
import { routes } from '../../../../routes';
import { t } from 'i18next';

const i18prefix = 'notifications.tickets.manager';
export const mapTicketManagerClosedNotificationRenderInfo = (
  src: NotificationQueryItem,
): NotificationItemData | null => {
  const data: NotificationItemData = {
    comment: '',
    urlLabel: '',
    url: '',
    description: '',
  };

  if (
    src.renderInfo.__typename === 'TicketManagerClosedNotificationRenderInfo'
  ) {
    if (!src.renderInfo.ticket?.Id) {
      return null;
    }

    data.description = t(`${i18prefix}.closed`, {
      employee: src.renderInfo.ticket?.employee?.Name,
    });
    data.icon = 'help-desk-outline';
    const requestId = src.renderInfo.ticket?.Id;
    if (requestId) {
      data.url = routes.managerTickets.route.create({
        id: requestId,
      });
    }

    const ticket = src.renderInfo.ticket;
    const subject = ticket?.subject;
    if (subject && subject.label) {
      data.urlLabel = subject.label;
    }
  }
  return data;
};
